/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './chip/Chip.module.scss';

const cx = classNames.bind(styles);

const Chip = (props) => {
  const { className = '', item, onRemove, icon, value, readonly } = props;
  const chipStyle = cx('chip', className.split(' '));

  const iconEl = icon || item.icon;

  return (
    <div
      tabIndex={0}
      className={'chip ' + chipStyle}
      onKeyDown={(e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
          onRemove(item);
          e.stopPropagation();
        }
      }}
    >
      {iconEl && (
        <i className={styles.icon}>
          {iconEl}
        </i>
      )}
      <span className={styles.label}>
        {item.label}
      </span>
      {value ? (
        <span className="ml-2">
          {value}
        </span>
      ) : null}
      {!readonly && (
        <button
          type="button"
          tabIndex={-1}
          className={`btn-close ${styles.remove}`}
          onClick={() => onRemove(item)}
        />
      )}
    </div>
  );
};

Chip.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    reactLabel: PropTypes.element,
    icon: PropTypes.element,
    isHeader: PropTypes.bool,
    value: PropTypes.any.isRequired,
    uncountable: PropTypes.bool,
  }),
  onRemove: PropTypes.func,
  icon: PropTypes.element,
  value: PropTypes.string,
  readonly: PropTypes.bool,
};

export default Chip;
